// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_container__3476p","container-option":"CheckBox_container-option__1QySO","checkmark":"CheckBox_checkmark__yRGjR","box-name":"CheckBox_box-name__atFT9"};